import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueCookies from 'vue-cookies'
import hooks from '@u3u/vue-hooks'
import Amplify from 'aws-amplify'
import { cognitoConfig } from './aws-config'
// Main JS (in UMD format)
import VueTimepicker from 'vue2-timepicker'

// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'
import './styles.css'
import 'v-tooltip/dist/v-tooltip.css'

import VTooltip from 'v-tooltip'
import VueWorker from 'vue-worker'
import VueVirtualScroller from 'vue-virtual-scroller'
import VirtualCollection from 'vue-virtual-collection'
import vClickOutside from 'v-click-outside'

Vue.use(hooks)
Vue.use(VueCompositionApi)
Vue.use(VueWorker)
Vue.use(VTooltip)
Vue.use(vClickOutside)
Vue.use(VirtualCollection)
Vue.use(VueVirtualScroller)
Vue.use(VueTimepicker)

Amplify.configure(cognitoConfig())

import '@aws-amplify/ui-vue'

import { cfg } from './lib/config'

Vue.prototype.$cfg = cfg
Vue.prototype.$api = cfg.apis

Vue.config.productionTip = false

import './fonts/WorkSans-Regular.ttf'
import './fonts/WorkSans-Light.ttf'
import './fonts/WorkSans-Bold.ttf'

Vue.use(VueRouter)
Vue.use(VueCookies)

import store from '@/lib/store'
import router from './router'

new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')

import frontendRegistration from '@/contexts/frontend/registration'

frontendRegistration(Vue)
